import {Container, Form, FormField, Grid, Header, Input, Textarea} from "@cloudscape-design/components";
import {DESCRIPTION_PLACEHOLDER, MAX_FLOW_STEPS, MIN_DESCRIPTION_LENGTH, MIN_FLOW_STEPS} from "../../constants";


export const Configuration = ({
                                  description, flowSteps, loading,
                                  onDescriptionChange, onInteractionFlowChange, flowStepsInvalid, descriptionInvalid,
                              }) => {
    return (
        <Container
            header={
                <Header variant="h2">Architecture configuration</Header>
            }
        >
            <form onSubmit={(event) => {event.preventDefault()}}>
                <Form>
                    <Grid
                        gridDefinition={[{colspan: 9}, {colspan: 3}]}
                    >
                        <FormField
                            label={'Description'}
                            stretch={true}
                            description={'Description of the architecture you want to generate.'}
                            errorText={descriptionInvalid? `The description must be at least ${MIN_DESCRIPTION_LENGTH} characters long.` : ''}
                        >
                            <Textarea
                                onChange={({detail}) => onDescriptionChange(detail.value)}
                                value={description}
                                placeholder={DESCRIPTION_PLACEHOLDER}
                                rows={4}
                                disabled={loading}
                            />
                        </FormField>

                        <FormField
                            label={'Interaction flow steps'}
                            description={'Number of steps used to explain the architecture flow.'}
                            errorText={flowStepsInvalid? `The value must be between ${MIN_FLOW_STEPS} and ${MAX_FLOW_STEPS}.` : ''}
                        >
                            <Input
                                invalid={flowStepsInvalid}
                                disabled={loading}
                                type={'number'}
                                value={flowSteps}
                                onChange={({detail}) => onInteractionFlowChange(detail.value)}
                            ></Input>
                        </FormField>
                    </Grid>
                </Form>
            </form>
        </Container>
    )
}